;(function($, undefined) {
    $(function() {
        var currentId = 0;

        $('.feature-box[data-list-for]').click(function() {
            var targetId = parseInt($(this).attr('data-list-for'));

            if (currentId === targetId) {
                return;
            }

            $('.feature-box[data-list-for]').removeClass('active');
            $(this).addClass('active');

            var $active = $('.tabbed-product-info__list[data-list-id=' + currentId + ']'),
                $target = $('.tabbed-product-info__list[data-list-id=' + targetId + ']');

            $active.slideUp(250, function() {
                $active.removeClass('active');
                setTimeout(function() {
                    $target.slideDown(250, function() {
                        $target.addClass('active');
                    });
                });
            });

            currentId = targetId;
        });
    });
})(jQuery);
